// extracted by mini-css-extract-plugin
export default {"text_transform":"OrdersTable_text_transform__Qb+Lh","table":"OrdersTable_table__CeH3i"};